import _styled from "styled-components";
import cn from "clsx";
import { css } from "styled-components";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProjectCardSkeleton = function ProjectCardSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsx("div", {
    className: cn('w-full flex flex-col flex-shrink-0 rounded-5 overflow-hidden', className),
    children: /*#__PURE__*/_jsxs("div", {
      className: cn('w-full flex', isDark ? 'bg-gray-main-dark-mode' : 'bg-white'),
      children: [/*#__PURE__*/_jsx(_StyledSkeleton, {
        className: "relative flex-shrink-0 w-1/3"
        // @ts-ignore
        ,

        isDark: isDark
      }), /*#__PURE__*/_jsxs("div", {
        className: "w-full flex flex-col justify-between p-8",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col mb-12",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: "w-1/3 h-20 mb-4",
            isDark: isDark
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "w-full h-20 mb-8",
            isDark: isDark
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex flex-col items-start",
          children: /*#__PURE__*/_jsx(Skeleton, {
            className: "w-160 h-32",
            isDark: isDark
          })
        })]
      })]
    })
  });
};
export default ProjectCardSkeleton;
var _StyledSkeleton = /*#__PURE__*/_styled(Skeleton).withConfig({
  componentId: "sc-1t5l9mf-0"
})(["\n          max-width: 224px;\n          ", " {\n            min-width: 160px;\n          }\n        "], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('md');
});